/// <reference path="../app.d.ts" />
import { isBot } from '../../Shared/helpers/browser-support-helper';

export function send(location: string) {
	// Remove all unused functions from this file when removing Features.DisablePageLoadingStats
	if (NewFeatures.DisablePageLoadStats) {
		return;
	}

	if (isBot()) {
		return;
	}
	if (!isSupported()) {
		return;
	}

	if (document.readyState === 'complete') {
		console.log('readyState is complete, sending stats');
		setTimeout(() => sendLoadTimes(location), 50);
	} else {
		console.log(`readyState is ${document.readyState}, waiting for doc to load `);
		window.addEventListener('load', () => { setTimeout(() => sendLoadTimes(location), 50); }, true);
	}
}

export function navigationStart() {
	return window.performance.timing.navigationStart;
}

export interface IStats {
	NavigationStart: Date;
}

export function createStats<TStats>(initial: Partial<TStats>): TStats & IStats {
	return { ...(initial as any), NavigationStart: new Date(navigationStart()) };
}

export function millisecondsSinceNavigationStart() {
	return Math.round(window.performance.now());
}

function sendLoadTimes(location: string) {
	console.log(`sendLoadTimes: readyState is ${document.readyState}`);
	const loadTimes = getLoadTimes(location);
	const queryString = convertToQueryString(loadTimes);
	const c = new XMLHttpRequest();

	c.open('GET', `/perf/loadtimes?${queryString}`);
	c.send();
}

function getPerformanceTiming() {
	return window.performance.timing;
}

function isSupported(): boolean {
	return !!(window.performance && window.performance.timing);
}

function isNumber(value: any): value is number {
	return typeof value === 'number';
}

function getLoadTimes(location: string): {} {
	const minValue = getPerformanceTiming().navigationStart;
	let data = getStandardLoadTimes();
	data = convertToIntervalSinceNavigationStart(minValue, data);

	data['start'] = minValue;
	data['location'] = location;

	return data;
}

function getStandardLoadTimes() {
	const data: { [key: string]: number | string } = {};

	const timing = window.performance.timing;

	// ReSharper disable once MissingHasOwnPropertyInForeach
	for (let name in timing) {
		const value = (timing as any)[name];
		if (isNumber(value)) {
			data[`t_${name}`] = value;
		}
	}

	return data;
}

function convertToIntervalSinceNavigationStart(navigationStart: number, data: { [key: string]: number | string }) {
	const result: { [key: string]: number | string } = {};
	for (let name in data) {
		if (data.hasOwnProperty(name)) {
			const value = data[name];
			result[name] = isNumber(value) ? (value !== 0 ? value - navigationStart : 'x') : navigationStart;
		}
	}
	return result;
}

function convertToQueryString(data: { [key: string]: string }) {
	const items = Object.getOwnPropertyNames(data)
		.sort((a, b) => a.localeCompare(b))
		.map(x => `${x}=${encodeURIComponent(data[x])}`);

	return items.join('&');
}
